import React from "react";
import HiveRentals from "../../assets/images/Services/young-beekeeper-man-clean-wooden-honey-frame-working-apiary-summer-day.jpg";
import AboutSectionSubsection1 from "../../components/AboutSection1/AboutSectionSubsection1";
import PollinationServices from "../../assets/images/Services/pollination-service.jpg";
import PollinationPlans from "../../assets/images/Services/pollination-plans.jpg";
import SustainabilityPractices from "../../assets/images/Services/eco-friendly.jpg";
import ConsultingEducation from "../../assets/images/Services/manage-eco-bee.jpg";


export default function FarmerServices() {
  const services = [
    {
      image: PollinationServices,
      id: "PollinationServices",
      title: "Expert Pollination Services",
      bodycopy:
        "ApisChain PSP offers professional, managed pollination services for a wide range of crops, including fruits, vegetables, nuts, and flowers. We place healthy, strong bee colonies on your farm at the optimal time for pollination, ensuring your crops receive the coverage they need to thrive. We work closely with you to determine the best time for hive placement and ensure that pollination is maximized across your farm.",
    },
    {
      rowreverse: "true",
      image: HiveRentals,
      id: "CFServices",
      title: "Hive Rentals",
      bodycopy:
        "Rent carefully maintained hives from ApisChain PSP for the duration of your crop’s flowering or blooming period. Our bees are healthy, productive, and ready to get to work. We provide ongoing hive management, ensuring that bees are well-fed, strong, and effective throughout the season, giving you peace of mind.",
    },
    {
        image: PollinationPlans,
        id: "PollinationServices",
        title: "Customized Pollination Plans",
        bodycopy:
          "Every farm is unique. ApisChain PSP offers customized pollination plans based on your specific crop types, farm layout, and local environmental conditions. Our team will assess your farm and tailor a solution that optimizes bee placement, timing, and management to meet the unique needs of your crops.",
      },
      {
        rowreverse: "true",
        image: ConsultingEducation,
        id: "CFServices",
        title: "Consulting & Education",
        bodycopy:
          "We don’t just offer services—we partner with you in the process. ApisChain PSP offers consulting on integrating bees into your farm’s operations, as well as educational workshops on pollinator health, hive management, and crop-specific pollination needs. Our experts will help you understand the key factors that influence successful pollination and how you can create a bee-friendly environment on your farm.",
      },
      {
        image: SustainabilityPractices,
        id: "PollinationServices",
        title: "Sustainable and Eco-Friendly Practices",
        bodycopy:
          "ApisChain PSP is committed to environmentally responsible beekeeping. We work with you to ensure your farm supports biodiversity and minimizes the use of harmful chemicals that could negatively impact pollinator health.Our sustainable farming approach means healthier ecosystems for your farm and your community.",
      },
  ];
  return (
    <div className="section-container container">
      {services.map((e, index) => {
        return (
          <AboutSectionSubsection1
          key={index}
          id={e.id}
          src={e.image}
          bodycopy={e.bodycopy}
          title={e.title}
          rowreverse={e.rowreverse}
        />
        );
      })}
    </div>
  );
}
